module.exports = __webpack_public_path__ + "static/media/sign-in-alt.4e13ba6a.svg";